import React, { useEffect } from 'react'
import { StaticQuery, graphql } from 'gatsby'

import Sidebar from './Sidebar'

import { withMicrocopy } from '~contexts/MicrocopyContext'

export const Component = ({
  className,
  microcopy,
  location
}) => {
  useEffect(() => {
    const element = document.querySelector('#sidebar [data-selected=true]')
    if (element) { element.scrollIntoView({ block: 'center' }) }
  }, [location])

  return (
    <StaticQuery
      query={ query }
      render={data => (
        <Sidebar 
          className={className}
          microcopy={microcopy} 
          location={location}
          tags={data.tags.nodes}
          resources={data.resources.nodes} />
    )} 
  />
  )
}

export const query = graphql`
  query {
    tags: allTag(sort: {fields: name}) {
      nodes {
        id
        name
        resources {
          id
          path
          title
        }
        endpoints {
          id
          urlPath
          title
          verb
        }
      }
    }
    resources: allResource(sort: {fields: key}, filter: {hide: {eq: false}}) {
      nodes {
        id
        path
        title
      }
    }
  }
`

export default withMicrocopy(Component)
